// File: src/components/AI/LowStockSuggester.jsx
import { useEffect, useMemo } from "react";
import { useAssistant } from "../../contexts/AssistantContext";
import { useMaterials } from "../../contexts/MaterialContext";
import { usePO } from "../../contexts/POContext";

export default function LowStockSuggester() {
  const { materials = [] } = useMaterials?.() ?? { materials: [] };
  const { addOrder /*, deleteOrder */ } = usePO?.() ?? { addOrder: () => {} };
  const { pushSuggestion, confirmable } = useAssistant();

  const low = useMemo(() => {
    return (materials || []).filter(
      (m) =>
        m?.lowStockLimit != null &&
        Number(m.quantity ?? m.startQuantity ?? 0) <= Number(m.lowStockLimit)
    );
  }, [materials]);

  useEffect(() => {
    if (!low.length) return;

    const title = `You're low on ${low.length} item${low.length > 1 ? "s" : ""}`;
    const details =
      low.slice(0, 3).map((m) => `• ${m.name} (${m.quantity ?? 0} left)`).join("\n") +
      (low.length > 3 ? `\n• +${low.length - 3} more…` : "");

    pushSuggestion({
      title,
      badge: "Auto-draft PO",
      details,
      actions: [
        {
          label: "Create PO draft",
          primary: true,
          onClick: async () => {
            const { ok } = await confirmable({
              title: "Create a draft Purchase Order?",
              details: `We'll add all low-stock items with suggested quantities.`,
              onConfirm: async () => {
                const items = low.map((m) => ({
                  id: m.id,
                  name: m.name,
                  qty: Math.max(Number(m.reorderQty || 1), 1),
                  unitCost: Number(m.unitCost || 0),
                }));
                const po = {
                  id: `PO-${Date.now()}`,
                  createdAt: Date.now(),
                  supplier: "TBD",
                  items,
                  status: "draft",
                  total: items.reduce((s, it) => s + it.qty * it.unitCost, 0),
                };
                addOrder?.(po);
                return po;
              },
              onUndo: async (po) => {
                // If your PO context provides a delete method, use it here.
                // deleteOrder?.(po.id);
              },
            });
            return ok;
          },
        },
        { label: "Review items", onClick: async () => true },
      ],
    });

    // fire once per mount per dataset size (prevents spam); tweak to taste
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [materials.length]);

  return null;
}
